var _a;
import { handleActions } from 'redux-actions';
import { NAMES } from '../actions/slide-menu';
export default handleActions((_a = {},
    _a[NAMES.OPEN_SLIDE_MENU] = function () { return true; },
    _a[NAMES.CLOSE_SLIDE_MENU] = function () { return false; },
    _a), false);
